<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title class="btn btn-rose">Add New Vendor</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="addVendorForm" (ngSubmit)="addVendorForm.valid && saveVendor()" novalidate>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>Vendor Code</mat-label>
                            <input matInput type="text" placeholder="Vendor Code" name="vendorCode" id="vendorCode" maxlength="15"
                                formControlName="vendorCode" required autocomplete="off" appInputValidator 
                                [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" />
                            <mat-error *ngIf="addVendorForm.get('vendorCode').hasError('required')">
                                Vendor Code is required (max 15 chars).
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('vendorCode').hasError('maxlength')">
                                Vendor Code cannot be more than 15 characters.
                              </mat-error>
                              <mat-error *ngIf="addVendorForm.get('vendorCode').hasError('noAlphabet')">
                                      Vendor Code must contain at least one alphabet character.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>Vendor Name</mat-label>
                            <input matInput type="text" placeholder="Vendor Name" name="vendorName" id="vendorName" maxlength="50"
                                formControlName="vendorName" required autocomplete="off"  appInputValidator 
                                [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" >
                            <mat-error *ngIf="addVendorForm.get('vendorName').hasError('required')">
                                Vendor Name is required (max 50 chars).
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('vendorName').hasError('maxlength')">
                                Vendor Name cannot be more than 50 characters.
                              </mat-error>
                                <mat-error *ngIf="addVendorForm.get('vendorName').hasError('noAlphabet')">
                                      Vendor Name must contain at least one alphabet character.
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>Description</mat-label>
                            <input matInput type="text" placeholder="Description" name="description" id="description" maxlength="100"
                                formControlName="description" appInputValidator 
                                [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" />
                            <mat-error *ngIf="addVendorForm.get('description').hasError('required')">
                                Description is required (max 100 chars).
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('description').hasError('maxlength')">
                                Description cannot be more than 100 characters.
                              </mat-error>
                                <mat-error *ngIf="addVendorForm.get('description').hasError('noAlphabet')">
                                      Description  must contain at least one alphabet character.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>Address</mat-label>
                            <input matInput type="text" placeholder="Address" name="address" id="address" maxlength="250"
                                formControlName="address" required autocomplete="off" appInputValidator 
                                [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" >
                            <mat-error *ngIf="addVendorForm.get('address').hasError('required')">
                                Address is required (max 250 chars).
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('address').hasError('maxlength')">
                                Description cannot be more than 250 characters.
                              </mat-error>
                               <mat-error *ngIf="addVendorForm.get('address').hasError('noAlphabet')">
                                      Address  must contain at least one alphabet character.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>EmailIds </mat-label>
                            <input matInput type="text" placeholder="Emails (e.g., aa@abc.com; bb@xyz.com)" name="emailIds" id="emailIds"
                                formControlName="emailIds" required autocomplete="off"   maxlength="100">
                            <mat-error *ngIf="addVendorForm.get('emailIds').hasError('required')">
                                EmailId is required.
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('emailIds').hasError('invalidEmailIds')">
                                Enter valid emails, separated by semicolons (max 100 chars).
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('emailIds').hasError('maxlength')">
                                Description cannot be more than 100 characters.
                              </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>Contact Numbers</mat-label>
                            <input matInput type="text" placeholder="Numbers (e.g., 1234567890; 0987654321)" name="Contact Numbers"
                                id="contactNumbers" formControlName="contactNumbers" required autocomplete="off" maxlength="100">
                            <mat-error *ngIf="addVendorForm.get('contactNumbers').hasError('required')">
                                Contact Number is required.
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('contactNumbers').hasError('invalidContactNumbers')">
                                Enter 10-digit numbers, separated by semicolons (max 100 chars).
                            </mat-error>
                            <mat-error *ngIf="addVendorForm.get('contactNumbers').hasError('maxlength')">
                                Contact Numbers cannot be more than 100 characters.
                              </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-card-content>
        <mat-card-footer>
            <br>
            <div class="row action-btn justify-content-center" style="padding-top: 10px;">
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="close()">Close</button>
                </div>
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="saveVendor()" [disabled]="!addVendorForm.valid">Save</button>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
</div>